angular.module('impactx.opengovernmentdata').controller('EnforcementAreaListCtrl', [EnforcementAreaListController]);

function EnforcementAreaListController() {
    var self = this;

    self.meta = {
        rowTemplate: 'modules/opengovernmentdata/templates/enforcementarealist.row.tmpl.html',
        isSelectAble: false,
        ctrl: self,
        endpoint: '/opengovernmentdata/enforcementarea/list',
        id: "enforcementarea",
        excelExport: true
    };

    self.getMeta = function () {
        return self.meta;
    };
}